export default "__VITE_ASSET__d34715dd__"